import React from 'react'
import styled from "styled-components"
import useSiteMetadata from '../hooks/use-site-config'
import useSiteImages from '../hooks/use-site-images'
import Link from '../components/link'
import Image from "gatsby-image"
import { Container, Row, Col } from "reactstrap";

const HomeNameImage = styled(Image)`
max-width: 200px;
`
const HomelogoImage = styled(Image)`
width: 64% !important;
margin-left: auto;
@media only screen and (max-width: 769px){
  width: 120% !important;;
}
`
const HeaderContainer = styled.header`
top: 0;
height: 90px;    
padding: 20px 0px;
display: table;
width: 100%;
overflow: hidden;
background: linear-gradient( 90deg, rgba(239, 130, 0, 1) 10%, rgba(228, 0, 169, 1) 50%, rgba(80, 35, 94, 1) 90% ) !important;
` 


const HeaderImg = ({ props, className }) => {
  const { rcName } = useSiteMetadata()
  const logoHeader = useSiteImages('Logo_header').fluid
  const { fluid } = useSiteImages(rcName)
  const img = fluid


  return (
    <HeaderContainer className={className} >
      <Container>
        <Row>
          <Col xs='4' sm="6">
            <Link to={"/"}>
              <HomeNameImage fluid={img} />
            </Link>
          </Col>
          <Col xs='7' sm="6">
            <HomelogoImage fluid={logoHeader} />
          </Col>
        </Row>
      </Container>
    </HeaderContainer>
  )
}

export default HeaderImg
